import require from '@/utils/request'
import { SystemSettings } from '@/types/System'
/**
 * SystemList 获取系统配置 webhook管理左侧系统配置列表
 * system/add 获取系统配置 webhook管理左侧系统配置新增
 * SystemDetail 获取系统配置 webhook管理左侧系统配置通过id获取单条数据
 * system/update 获取系统配置 webhook管理左侧系统配置更新

 */
export const SystemList = () => require({
  url: '/system/list',
  method: 'get'
})

export const SystemAdd = (data:SystemSettings) => require({
  url: '/system/add',
  method: 'post',
  data
})
export const SystemDetail = (id:number) => require({
  url: '/system/detail/' + id,
  method: 'get'
})
export const SystemUpdata = (data:SystemSettings) => require({
  url: '/system/update',
  method: 'post',
  data
})
